export const useIsMobile = () => {
    return window.innerWidth < 724;
}

export default useIsMobile;